/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { ServicePointDeliveryModel } from '@/api/service-point/delivery/delivery.model';
import { servicePointService } from '@/api/service-point/service-point/service-point.service';
import OrderSteps from '@/modules/service-point/components/order/order-steps/order-steps.component.vue';
import orderState from '@/modules/service-point/constants/order.constant';

/**
 * Component.
 */
@Component({
  components: { 'order-steps': OrderSteps },
  name: 'deliver-order-list-scene'
})
export default class extends Vue {
  /**
   * Property `isLoadingData`.
   */
  isLoadingData = false;

  /**
   * Property `deliveries`.
   */
  deliveries: ServicePointDeliveryModel[] = [];

  /**
   * Lifecycle created hook.
   */
  created() {
    this.handleGetDeliveries();
  }

  /**
   * Handle get deliveries.
   */
  async handleGetDeliveries() {
    try {
      this.isLoadingData = true;

      const response =
        (await servicePointService.getOrders({
          status: orderState.RECEIVED
        })) || [];

      response.forEach(item => {
        const { delivery, id, packages, statusDate: expectedDeliveryDate } =
          item || {};
        const { client, orderCode, trackingNumber } = delivery || {};
        const { name } = client || {};

        this.deliveries = [
          ...this.deliveries,
          {
            client: { name },
            expectedDeliveryDate,
            id,
            orderCode,
            packages,
            trackingNumber
          }
        ];
      });
    } catch (error) {
      if (process.env.BUILD_MODE !== 'prd') {
        console.error({ error, method: 'handleGetDeliveries' });
      }
    } finally {
      this.isLoadingData = false;
    }
  }

  /**
   * Handle select deliver.
   */
  handleSelectDeliver({ order }) {
    this.$router.push({
      name: 'ServicePointDeliverOrderWithoutPinConfirm',
      params: {
        packages: order?.packages || [],
        servicePointOrderId: String(order?.id),
        trackingNumber: String(order?.trackingNumber)
      }
    });
  }

  /**
   * Handle go back.
   */
  handleGoback() {
    this.$router.back();
  }
}
